export const describeWithOptions = (
  name: string,
  description: string,
  width: number,
  height: number
) => {
  return {
    name,
    description,
    height: height,
    width: width,
  };
};
